import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import CoreProductActionsSlice from '../CoreProductActionsBlock/CoreProductActionsSlice';

export default class CoreProductActionsInitializableModule implements IInitializableModule {
  protected name: string = 'core product actions module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'coreProductActions',
      reducer: CoreProductActionsSlice,
    };
  }
}